import { useEffect, useRef } from 'react';

const VideoCacheManager = () => {
  const serviceWorkerRegistered = useRef(false);

  useEffect(() => {
    // Register service worker for video caching
    if ('serviceWorker' in navigator && !serviceWorkerRegistered.current) {
      navigator.serviceWorker
        .register('/video-cache-sw.js')
        .then((registration) => {
          console.log('Video Cache Service Worker registered:', registration);
          serviceWorkerRegistered.current = true;
        })
        .catch((error) => {
          console.error('Video Cache Service Worker registration failed:', error);
        });
    }

    // Preload video for better performance
    const preloadVideo = () => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.muted = true;
      video.style.display = 'none';
      
      // Add sources
      const mp4Source = document.createElement('source');
      mp4Source.src = '/play_claww.mp4';
      mp4Source.type = 'video/mp4';
      
      const webmSource = document.createElement('source');
      webmSource.src = '/play_claww.webm';
      webmSource.type = 'video/webm';
      
      video.appendChild(mp4Source);
      video.appendChild(webmSource);
      
      // Start loading
      video.load();
      
      // Clean up after metadata is loaded
      video.addEventListener('loadedmetadata', () => {
        console.log('Video metadata preloaded');
        document.body.removeChild(video);
      });
      
      // Add to DOM temporarily
      document.body.appendChild(video);
    };

    // Preload video after a short delay to not block initial page load
    const preloadTimer = setTimeout(preloadVideo, 2000);
    
    return () => {
      clearTimeout(preloadTimer);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default VideoCacheManager;
